import { memo, useMemo } from 'react';
import type { Brand, CustomBrandDivision } from '@apiTypes';
import { Heading, Text, VStack } from '@library';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import styles from './BrandsListDivisionBrands.module.scss';
import BrandItem from './BrandItem/BrandItem';

const BrandsListDivisionBrands = ({
    division,
    brands,
    onBrandSelect,
}: {
    division: CustomBrandDivision;
    brands: Brand[];
    onBrandSelect?: () => void;
}) => {
    const { language } = useStoreAndLanguageParams();

    const sortedDivisionBrands = useMemo(
        () => division.brands.slice().sort((a, b) => a.localeCompare(b)),
        [division.brands]
    );

    const brandDictionary = useMemo(
        () =>
            Object.fromEntries(brands.map(item => [item.slug, item])) as Record<
                string,
                Brand | undefined
            >,
        [brands]
    );

    return (
        <VStack gap="small" key={division.name[language]}>
            <Heading bold h3>
                {division.name[language]}
            </Heading>
            <Text>{division.description[language]}</Text>

            <div className={styles.grid}>
                {sortedDivisionBrands.map(
                    divisionBrand =>
                        brandDictionary[divisionBrand] && (
                            <BrandItem
                                division
                                key={divisionBrand}
                                onBrandSelect={onBrandSelect}
                                brand={brandDictionary[divisionBrand]}
                            />
                        )
                )}
            </div>
        </VStack>
    );
};

export default memo(BrandsListDivisionBrands);
